import BaseSvg from "./BaseSvg";

export default BaseSvg;
export * from "./BaseSvgTypings";
export { BaseSvg };
